import produce from 'immer';
import useObservable from 'packages/workspace/modules/helpers/hooks/useObservable';
import { BehaviorSubject } from 'rxjs';

// loading : true false - interface sub and setState

export interface IUiState {
  isLoading: boolean;
  success_message: string;
  error_message: string;
  info_message: string;
  sound_type: string;
  disableNavigation?: boolean;
}

const initialState: IUiState = {
  disableNavigation: false,
  isLoading: false,
  success_message: '',
  error_message: '',
  info_message: '',
  sound_type: '',
};
const subject = new BehaviorSubject(initialState);

type UiStoreMessageTypes = keyof Omit<IUiState, 'isLoading' | 'sound_type'>;

const setUiStoreMessage = (type: UiStoreMessageTypes, message: string): void => {
  const state = produce(subject.value, (draftState) => {
    draftState[type] = message;
  });
  subject.next(state);
};

export const uiStore = {
  /**
   * Used to Set Loader
   * @param loading
   */
  setLoader: (loading: boolean): void => {
    const state = produce(subject.value, (draftState) => {
      draftState.isLoading = loading;
    });
    subject.next(state);
  },
  /**
   * used to set Success Message
   * @param message
   */
  setSuccessMessage: (message: string): void => {
    setUiStoreMessage('success_message', message);
  },
  /**
   * Clears Success Message
   */
  clearSuccessMessage: (): void => {
    setUiStoreMessage('success_message', '');
  },
  /**
   * Sets Error Message
   * @param message
   */
  setErrorMessage: (message: string): void => {
    setUiStoreMessage('error_message', message);
  },
  /**
   * Clears Error Messages
   */
  clearErrorMessage: (): void => {
    setUiStoreMessage('error_message', '');
  },
   /**
   * Sets Info Message
   * @param message
   */
   setInfoMessage: (message: string): void => {
    setUiStoreMessage('info_message', message);
  },
  /**
   * Clears Error Messages
   */
  clearInfoMessage: (): void => {
    setUiStoreMessage('info_message', '');
  },

  setSoundType: (sound_type: string): void => {
    const state = produce(subject.value, (draftState) => {
      draftState.sound_type = sound_type;
    });
    subject.next(state);
  },

  setNavigationDisabled: (shouldDisable = false): void => {
    const state = produce(subject.value, (draftState) => {
      draftState.disableNavigation = shouldDisable;
    });
    subject.next(state);
  },
};

export default function useUiState(): IUiState {
  return useObservable<IUiState>(subject, subject.value);
}
